/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExcludedCompanyAdd } from './excludedCompanyAdd';

export interface AddExcludedCompaniesRequest {
  /**
     * @minItems 1
     * @maxItems 500
     */
  items: ExcludedCompanyAdd[];
}
